<mat-spinner *ngIf="loading" color="primary" diameter="48"></mat-spinner>

<ng-container *ngIf="!loading && !!detail && !!adjustment">
  <div class="outer-container">
    <client-adjustment-header
      [type]="type"
      [title]="title"
      [projectContacts]="detail.projectContacts"
      [requestContact]="subProjectContact"
      [extraCompanyContacts]="detail.projectExtraCompanyContacts"
      [client]="true"
      [currentCreatedAt]="adjustment.currentCreatedAt"
      [approved]="detail.approved"
      [approvedRegistration]="detail.approvedRegistration"
    >
    </client-adjustment-header>

    <client-adjustment-summary
      [address]="detail.address"
      [placementFloor]="detail.placementFloor"
      [secondBoard]="detail.secondBoard"
      [otherOrderPlacementInfo]="detail.otherOrderPlacementInfo"
      [products]="detail.products"
      [originalProjectId]="baseProjectId"
      [adjustment]="adjustment"
      [executionAssets]="executionAssets"
      [form]="form"
      [executed]="executed"
    ></client-adjustment-summary>

    <div class="executed-container">
      <div class="executed__data-container">
        <ng-container *ngIf="!!executed; else formView">
          <client-adjustment-pending-executed
            [type]="type"
            [adjustment]="adjustment"
            [projectContacts]="detail.projectContacts"
            [arrows]="arrows"
            [secondBoard]="detail.secondBoard"
            [otherOrderPlacementInfo]="detail.otherOrderPlacementInfo"
            [executed]="executed"
          ></client-adjustment-pending-executed>
        </ng-container>

        <ng-template #formView>
          <ng-container *ngIf="!!form; else readOnly">
            <client-adjustment-form
              [type]="type"
              [readOnly]="!form && !executed"
              [client]="true"
              [adjustment]="adjustment"
              [products]="detail.products"
              [address]="detail.address"
              [placementFloor]="detail.placementFloor"
              [projectContacts]="detail.projectContacts"
              [secondBoard]="detail.secondBoard"
              [otherOrderPlacementInfo]="detail.otherOrderPlacementInfo"
              [minDate]="minDate"
            ></client-adjustment-form>
          </ng-container>

          <ng-template #readOnly>
            <client-adjustment-pending-executed
              [type]="type"
              [adjustment]="adjustment"
              [projectContacts]="detail.projectContacts"
              [arrows]="arrows"
              [secondBoard]="detail.secondBoard"
              [otherOrderPlacementInfo]="detail.otherOrderPlacementInfo"
              [executed]="executed"
            ></client-adjustment-pending-executed>
          </ng-template>
        </ng-template>
      </div>

      <div
        *ngIf="
          designAssets?.length > 0 ||
          (type === 'adjustment' &&
            !form &&
            adjustmentExternalAssets.length > 0) ||
          pdfList?.length > 0
        "
        [class.pdf-name-display-space]="
          pdfList?.length > 0 &&
          (designAssets == null ||
            designAssets.length === 0 ||
            adjustmentExternalAssets == null ||
            adjustmentExternalAssets.length === 0)
        "
      >
        <div
          *ngIf="
            designAssets?.length > 0 ||
            (type === 'adjustment' &&
              !form &&
              adjustmentExternalAssets.length > 0)
          "
          class="d-flex"
        >
          <div
            *ngIf="designAssets?.length > 0"
            class="executed__image-container w-100"
          >
            <img
              *ngIf="isImage(designAssets[0])"
              class="max-summary-width max-summary-height clickable"
              src="/api/assets/{{ designAssets[0].uuid }}"
              (click)="openLightbox()"
            />
          </div>

          <div
            *ngIf="
              type === 'adjustment' &&
              !form &&
              adjustmentExternalAssets.length > 0
            "
            class="executed__image-container w-100"
          >
            <img
              *ngIf="isImage(adjustmentExternalAssets[0].asset)"
              class="max-summary-width max-summary-height clickable"
              src="/api/assets/{{ adjustmentExternalAssets[0].asset.uuid }}"
              (click)="openAdjustmentExternalLightbox()"
            />
          </div>
        </div>

        <div
          *ngIf="pdfList?.length > 0"
          class="pdf-container executed__image-container"
          [class.mt-3]="
            designAssets?.length > 0 ||
            (type === 'adjustment' &&
              !form &&
              adjustmentExternalAssets.length > 0)
          "
        >
          <ul>
            <li *ngFor="let pdf of pdfList">
              <a
                target="_blank"
                href="/api/assets/{{ pdf.uuid }}"
                class="d-flex box"
              >
                <mat-icon> picture_as_pdf </mat-icon>

                <div class="filename">{{ pdf?.name }}</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <client-adjustment-execution-info
      *ngIf="!form"
      [products]="detail.products"
      [adjustment]="adjustment"
      [client]="true"
    ></client-adjustment-execution-info>

    <sticker-facturation
      *ngIf="type === 'soldrented' && projectHasIPBoards"
      [projectId]="projectId"
      [subProject]="adjustment"
      [product]="detail.products[0]"
      [secondBoardPresent]="detail.secondBoard != null"
      [numInvolvedCompanies]="numInvolvedCompanies"
      [invoice]="matchingProjectInvoice"
      [displayCompanyName]="false"
    ></sticker-facturation>
  </div>

  <client-adjustment-actions
    *ngIf="form"
    [type]="type"
    [projectId]="projectId"
    [adjustment]="adjustment"
    [minDate]="minDate"
    [products]="detail.products"
  ></client-adjustment-actions>

  <a
    *ngIf="!form && !executed"
    class="mail-link"
    href="{{ mail(detail.projectContacts[0]) }}"
  >
    <mat-icon class="icon-xl">email</mat-icon>
  </a>
</ng-container>
